import { reactive, watch } from 'vue';
import api from './api';
import router from './router';

const STORAGE_KEY = 'auth_data';

// Helper to load initial state from localStorage
const savedState = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');

export const authState = reactive({
  isLoggedIn: savedState.isLoggedIn || false,
  role: savedState.role || 'Guest',
  username: savedState.username || null,
  sipUser: savedState.sipUser || null,
  sipToken: savedState.sipToken || null,
  isInitialized: false,
});

// Watch for changes and sync to localStorage automatically
watch(
  () => ({ ...authState }), // Clone the object to track changes
  (newState) => {
    const { isInitialized, ...toStore } = newState; // Don't persist initialization flag
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toStore));
  },
  { deep: true }
);

export const handleLogin = async (credentials: Record<string, string>) => {
  try {
    const res = await api.post('/api/login', credentials);
    
    Object.assign(authState, {
      isLoggedIn: true,
      role: res.data.role,
      username: res.data.username,
      sipUser: res.data.sip_user,
      sipToken: res.data.sip_token,
      bridge_callers: res.data.bridge_callers,
      bridge_broadcast: res.data.bridge_broadcast
    });

    router.push('/');
  } catch (err) {
    throw err;
  }
};

export const checkSession = async () => {
  try {
    const res = await api.get('/api/me');
    authState.isLoggedIn = res.data.is_logged_in;
    authState.role = res.data.role;
    authState.username = res.data.username;
  } catch (err) {
    // If session is invalid, clear the state
    handleLogout(false); 
  } finally {
    authState.isInitialized = true;
  }
};

export const handleLogout = async (redirect = true) => {
  try {
    await api.post('/api/logout');
  } finally {
    // Clear state and localStorage
    authState.isLoggedIn = false;
    authState.role = 'Guest';
    authState.username = null;
    authState.sipUser = null;
    authState.sipToken = null;
    authState.bridge_callers = null;
    authState.bridge_broadcast = null;
    localStorage.removeItem(STORAGE_KEY);
    
    if (redirect) router.push('/login');
  }
};
